module.exports = __webpack_public_path__ + "static/media/icon_list_comment.34ac6828.svg";